import { TRootState } from 'core/store/reducers';
import { ILayoutState } from './types';

export const layoutSelector = (state: TRootState): ILayoutState => state.layout;
export const cartLayoutSelector = (state: TRootState): boolean => state.layout.cart;
export const menuLayoutSelector = (state: TRootState): boolean => state.layout.menu;
export const searchLayoutSelector = (state: TRootState): string => state.layout.search;
export const notFoundLayoutSelector = (state: TRootState): boolean => state.layout.isNotFound;
export const addressModalLayoutSelector = (state: TRootState): boolean => state.layout.isAddressModalOpen;
export const layoutErrorLayoutSelector = (state: TRootState) => state.layout.layoutError;
export const notifiedProductsLayoutSelector = (state: TRootState) => state.layout.notifiedProducts;
